// reducers/agentReducer.ts
import {
    ADD_KEY_KNOW_REQUEST,
    ADD_KEY_KNOW_SUCCESS,
    ADD_KEY_KNOW_FAILURE
} from '../../actions';


const initialState = {
    loading: false,
    data: [],
    error: '',
  };

const addKnowReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case ADD_KEY_KNOW_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case ADD_KEY_KNOW_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case ADD_KEY_KNOW_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.error
            };
        default:
            return state;
    }
};

export default addKnowReducers;
